/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";
import { Iceutility } from '../../services/iceutility';
import { AccountingService } from '../../services/accounting/accounting.service';

export class accountingfilter extends IceEntity {
  journal: string = "";
  from_date: any = NaN;
  to_date: any = NaN;
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  keyword: string = "";
  coa_type: IceTypes.coa_types = IceTypes.coa_types.coaNone;
  cosmetic_option: boolean = false;
  tax_status: IceTypes.sales_tax_status = IceTypes.sales_tax_status.stsNonTaxable;
  debit: number = 0.0;
  credit: number = 0.0;
  dataJournal: any[] = null;
  originalData: any[] = [];

  debitTotal: number = 0.0;
  creditTotal: number = 0.0;

  constructor(data: any[], jrnl: string, coatype: IceTypes.coa_types) {
    super();

    this.journal = jrnl;
    this.coa_type = coatype;

    if (data != null) {
      data.sort(function (a, b) { return b.journal_date - a.journal_date });
      this.originalData = data;
      let records = [];
      this.creditTotal = 0.0;
      this.debitTotal = 0.0;
      for (let i = 0; i < data.length; i++) {
        let rec = data[i];
        let entry = this.updateEntry(rec, true);
        if (entry != null) {
          records.push(entry);
          let debit = Iceutility.toDouble(rec.debit),
            credit = Iceutility.toDouble(rec.credit);

          this.creditTotal += credit;
          this.debitTotal += debit;
        }
      }
      this.dataJournal = records;
    }
  }

  copyEntry(entry: any): any {
    let dataEntry = null;
    if (entry == null) return null;

    // pull the object from data
    let foundData = null;
    // update specific journal fields
    switch (this.journal) {
      case IceTypes.JournalType.jtAsset: {
        foundData = this.originalData.filter(j => j.asset_journal_key == entry.journal_key);
        break;
      }
      case IceTypes.JournalType.jtExpense: {
        foundData = this.originalData.filter(j => j.expense_journal_key == entry.journal_key);
        break;
      }
      case IceTypes.JournalType.jtLiability: {
        foundData = this.originalData.filter(j => j.liability_journal_key == entry.journal_key);
        break;
      }
      case IceTypes.JournalType.jtIncome: {
        foundData = this.originalData.filter(j => j.income_revenue_journal_key == entry.journal_key);
        break;
      }
      case IceTypes.JournalType.jtInventory: {
        foundData = this.originalData.filter(j => j.other_items_journal_key == entry.journal_key);
        break;
      }
    }

    if (foundData == null) return null;
    if (foundData.length > 0) {
      for (let colName of Object.keys(foundData[0])) {
        if (entry[colName] == null) continue;
        foundData[0][colName] = entry[colName];
      }
      dataEntry = foundData[0];
    }
    else {
      // new
      this.originalData.push(entry);
      dataEntry = entry;
    }
    return dataEntry;
  }

  updateEntry(rec: any, newRec: boolean): any {
    if (rec == null) return null;
    let entry = null;
    let key = "";

    switch (this.journal) {
      case IceTypes.JournalType.jtAsset: {
        key = rec.asset_journal_key;
        break;
      }
      case IceTypes.JournalType.jtExpense: {
        key = rec.expense_journal_key;
        break;
      }
      case IceTypes.JournalType.jtLiability: {
        key = rec.liability_journal_key;
        break;
      }
      case IceTypes.JournalType.jtIncome: {
        key = rec.income_revenue_journal_key;
        break;
      }
      case IceTypes.JournalType.jtInventory: {
        key = rec.other_items_journal_key;
        break;
      }
      default:
        return null;
    }

    let amt = 0.0,
      debit = Iceutility.toDouble(rec.debit),
      credit = Iceutility.toDouble(rec.credit);
    if (debit == 0)
      amt = credit;
    else
      amt = debit;

    let account_type = Iceutility.toLong(rec.account_type);

    if (newRec) {
      entry = {
        select: false,
        journal_key: key,
        medical_service_key: rec.medical_service_key,
        journal_date: Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date)),
        trans_account: rec.trans_account,
        account_type: account_type,
        coa_type: AccountingService.getCoaType(rec.coa_type),
        journal_desc: rec.journal_desc,
        journal_note: rec.journal_note,
        journal_code: rec["journal_code"] != null ? rec["journal_code"] : "",
        last_name: rec.last_name,
        quantity: Iceutility.isdefined(rec.quantity) ? rec.quantity : "",
        debit: debit,
        credit: credit,
        amount: amt,
        increase: true
      };
    }
    else {
      let foundData = [];
      switch (this.journal) {
        case IceTypes.JournalType.jtAsset: foundData = this.dataJournal.filter(j => j.journal_key == rec.asset_journal_key); break;
        case IceTypes.JournalType.jtExpense: foundData = this.dataJournal.filter(j => j.journal_key == rec.expense_journal_key); break;
        case IceTypes.JournalType.jtLiability: foundData = this.dataJournal.filter(j => j.journal_key == rec.liability_journal_key); break;
        case IceTypes.JournalType.jtIncome: foundData = this.dataJournal.filter(j => j.journal_key == rec.income_revenue_journal_key); break;
        case IceTypes.JournalType.jtInventory: foundData = this.dataJournal.filter(j => j.journal_key == rec.other_items_journal_key); break;
      }

      if (foundData.length > 0) {
        entry = foundData[0];
        entry.journal_date = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(rec.journal_date));
        entry.trans_account = rec.trans_account;
        entry.account_type = rec.account_type;
        entry.coa_type = AccountingService.getCoaType(rec.coa_type);
        entry.journal_desc = rec.journal_desc;
        entry.journal_note = rec.journal_note;
        entry.journal_code = rec["journal_code"] != null ? rec["journal_code"] : "";
        entry.last_name = rec.last_name;
        entry.quantity = Iceutility.isdefined(rec.quantity) ? rec.quantity : "";
        entry.debit = debit;
        entry.credit = credit;
        entry.amount = amt;
        entry.increase = true;
      }
    }
    return entry;
  }

  hasSelection(): boolean {
    if (this.dataJournal == null || this.dataJournal.length == 0) return false;
    for (let i = 0; i < this.dataJournal.length; i++) {
      if (this.dataJournal[i].select == true) return true;
    }
    return false;
  }
}
